import {useState} from "react";

function getDirtyFields(formValue: FormObj): Dictionary<any> {
    const dirty: Dictionary<any> = {};
    const values = formValue.fieldValues;
    const touched = formValue.touchedFields;
    const initial = formValue.initialValues;
    const initialValues = initial || {};


    for (const [key] of Object.entries(touched)) {
        if(values[key] === undefined) {
            continue;
        }
        if(typeof touched[key] === "object") {
            dirty[key] = getDirtyFields({
                fieldValues: values[key],
                errors: formValue.errors?.[key],
                touchedFields: formValue.touchedFields[key],
                initialValues: initialValues[key],
            })
        } else {
            if(JSON.stringify(values[key]) !== JSON.stringify(initialValues[key])) {
                dirty[key] = true;
            }
            if(values[key] === "" && initialValues[key] === undefined || values[key] === false && initialValues[key] === undefined) {
                dirty[key] = false;
            }
        }

    }
    return dirty;
}

export function isDirty(formValue: FormObj): boolean {
    for (const [key, val] of Object.entries(getDirtyFields(formValue))) {
        if (typeof val === "object") {
            if (isDirty({
                fieldValues: formValue.fieldValues[key],
                errors: formValue.errors?.[key],
                touchedFields: formValue.touchedFields?.[key],
                initialValues: formValue.initialValues?.[key],
            })) {
                return true;
            }
        } else if (val) {
            return true;
        }
    }
    return false;
}

export function hasError(errors: Dictionary<any>): boolean {
    if(errors === undefined) {
        return false;
    }
    for (const [key, val] of Object.entries(errors)) {
        if (typeof val === "object") {
            if (hasError(errors?.[key])) {
                return true;
            }
        } else if (val) {
            return true;
        }
    }
    return false;
}

export function collectErrors(errors: Dictionary<any>): Dictionary<any> {
    const newErrors: Dictionary<any> = {};
    if(errors === undefined) {
        return {};
    }
    for (const [key, val] of Object.entries(errors)) {
        if (typeof val === "object") {
            if(val.label && val.text) {
                newErrors[val.label] = val.text;
            }
            else if (hasError(errors?.[key])) {
                for (const [k, v] of Object.entries(collectErrors(errors?.[key]))) {
                    newErrors[k] = v;
                }
            }
        }
    }
    return newErrors;
}

export function useForm(): [FormObj & { dirtyFields: Dictionary<any> }, (key: keyof FormObj, value: Dictionary<any>) => void] {
    const [formValue, setFormValue] = useState<FormObj>({
        fieldValues: {},
        errors: {},
        touchedFields: {},
        initialValues: {}
    })

    const [dirtyFields, setDirtyFields] = useState<Dictionary<any>>({});

    function onFormValChange(key: keyof FormObj, value: Dictionary<any>) {

        setFormValue((v) => {
            const newVal = {
                ...v,
                [key]: value
            }
            setDirtyFields(getDirtyFields(newVal));
            return newVal;
        });
    }

    return [
        {
            ...formValue,
            dirtyFields: dirtyFields,
        },
        onFormValChange,
    ]
}

export function clearTouchedFields(formValue: FormObj): Dictionary<any> {
    const touched = formValue.touchedFields;
    const newTouched: Dictionary<any> = {};
    for (const [key, val] of Object.entries(touched)) {
        if (typeof val === "object") {
            newTouched[key] = clearTouchedFields({
                fieldValues: formValue.fieldValues[key],
                errors: formValue.errors?.[key],
                touchedFields: formValue.touchedFields[key],
                initialValues: formValue.initialValues?.[key],
            }).touchedFields;
        } else {
            newTouched[key] = false;
        }
    }
    return newTouched;
}

export function EmailValidator(val: any, label: string): {label: string, text: string} | undefined {
    const match = String(val)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    if(match && match.length > 0) {
        return undefined;
    } else {
        return  {label, text:"Valódi e-mail címet adj meg!"};
    }
}

export function RequiredValidator(val: any, label: string): {label: string, text: string} | undefined {
    if(val === undefined || val === "" || val === null) {
        return {label, text:"Ez a mező kötelező!"};
    }
    return undefined;
}